export default [
  {
    content: "회전기기의 조립·설치 회전방향 및 정상 작동 상태를 확인하였는가?",
    isChecked: "",
  },
  {
    content: "최초 설치 시 축정렬을 실시하고 커플링 설치 상태도 적정하게 유 관리하고있는가?",
    isChecked: "",
  },
  {
    content: "흡입 측으로 이물질이 유입되지 않도록 필요시 필터 또는 스트레이너를 설치하는가?",
    isChecked: "",
  },
  {
    content: "폭발 위험장소에 위치하는 경우, 회전기기 모터를 방폭형으로 설치하였는가?",
    isChecked: "",
  },
  {
    content: "펌프, 압축기의 토출 측에 체크밸브 및 압력계가 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "정변위(용적식) 펌프 및 압축기를 과압으로부터 보호하기 위해 안전밸브가 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "온도계, 압력계, 유랑계 등 게측장치가 설치되어 있고, 파손되거나 고장 없이 정상 기능을 유지하고 있는가?",
    isChecked: "",
  },
  {
    content: "회전 부위에 방호덮개, 울 등이 설치되어 있고 파손 또는 탈락 없이 정상 기능을 유지하고 있는가?",
    isChecked: "",
  },
  {
    content: "윤활유가 준비되어 있고 회전기기에 제대로 주입되어 있는가?",
    isChecked: "",
  },
  {
    content: "기름걸레(면보루)는 사용 후 뚜껑이 달린 불연성 용기에 보관하고, 최대한 빠른 시일 내에 처리하는가?",
    isChecked: "",
  },
  {
    content: "펌프와 압축기 흡입 및 토출 측 배관에 적정한 재질과 규격의 개스킷이 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "다단압축기 가동 시 중간냉각기(Intercooler)로 냉각수 또는 냉동수를 공급하고 순환 관련 정상 작동 상태를 확인하는가?",
    isChecked: "",
  },
  {
    content: "공기압축기 토출 배관, 공기저장탱크, 유분리기를 주기적으로 점검하여 윤활유 및 탄화물 축적 여부를 확인하는가?",
    isChecked: "",
  },
  {
    content: "펌프와 압축기 설비에 누설은 없는지 육안으로 자주 확인하는가?",
    isChecked: "",
  },
  {
    content: "가연성 가스 압축기의 실링용 오일 속에 용해된 가연성 가스의 폭발성 혼합기 형성으로 인한 윤활유 탱크의 폭발 방지를 위해 탱크에 질소를 충진하였는가?",
    isChecked: "",
  },
];
